import { render } from "./Notice.vue?vue&type=template&id=198067dc&ts=true"
import script from "./Notice.vue?vue&type=script&lang=ts"
export * from "./Notice.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__